import {
  Box,
  Paper,
  Table,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { blueGrey, grey } from "@mui/material/colors";
import { useEffect } from "react";

const infoTableCellSx = {
  fontSize: 17,
};
const HistoryContainerItem = (props) => {
  const { containers } = props;
  const columns = ["No", "日付", "得意先", "前日在庫数", "コンテナ数", "差引"];

  return (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: 350, overflowY: "scroll" }}
    >
      <Table sx={{ minWidth: 850 }}>
        <TableHead>
          <TableRow>
            {columns.map((columnName, i) => {
              return (
                <TableCell
                  key={`${columnName}_${i}`}
                  sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                >
                  {columnName}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {containers.map((data, index) => (
            <TableRow
              key={"historyContainerRow" + index}
              sx={{
                "&:hover": {
                  backgroundColor: blueGrey[50],
                },
              }}
            >
              {/*  */}
              <TableCell sx={{ ...infoTableCellSx, width: 50 }}>
                {index + 1}
              </TableCell>
              {/* 中分類 */}
              <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                {data.containerShippedAt}
              </TableCell>
              {/* 小分類 */}
              <TableCell sx={{ ...infoTableCellSx, width: 500 }}>
                {data.buyerNo + "-" + data.buyerName}
              </TableCell>
              {/* 税率 */}
              <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                {data.rentingQuantity}
              </TableCell>
              {/* 税率 */}
              <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                {data.quantity}
              </TableCell>
              {/* 産地 */}
              <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                {parseInt(data.rentingQuantity) - parseInt(data.quantity) > 0
                  ? parseInt(data.rentingQuantity) - parseInt(data.quantity)
                  : 0}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HistoryContainerItem;
